import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { normalizeOnboardingSiteUrl } from '../utils';
import { ONBOARDING_FLOWS } from '../constants';

export function useOnboardingContext(currentUserFlow) {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const flow = searchParams.get('flow') ?? currentUserFlow;
    const tech = searchParams.get('tech');
    const view = searchParams.get('view');
    const recommendation = searchParams.get('recommendation');
    const siteUrl = normalizeOnboardingSiteUrl(searchParams.get('site_url'));
    const heatmapUrl = normalizeOnboardingSiteUrl(searchParams.get('heatmap_url'));
    const isHeatmapFlow = flow === ONBOARDING_FLOWS.HEATMAPS;
    const completionUrl = isHeatmapFlow ? heatmapUrl || siteUrl : siteUrl || heatmapUrl;

    return {
      flow,
      siteUrl,
      heatmapUrl,
      isHeatmapFlow,
      completionUrl,
      tech,
      view,
      recommendation,
    };
  }, [searchParams, currentUserFlow]);
}
